import { AlarmLevel } from "ops/common/models/alarm-level";

export enum AlarmDataSort {
    DESC = 'desc',
    ASC = 'asc',
}

export interface AlarmStatusCount {
    [AlarmLevel.Alarm]: number;
    [AlarmLevel.Caution]: number;
    [AlarmLevel.Warning]: number;
}
